import React from "react";
import { Box, Button, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const BasicButtons = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Basic Buttons
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          The Button comes with five variants: contained (default), outlined,
          Text, Tonal and NoPadding.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          title={"five variants of Button"}
          language={"js"}
          value={
            "        <Button>Contained</Button>\n" +
            '        <Button variant={"outlined"}>outlined</Button>\n' +
            '        <Button variant={"text"}>text</Button>\n' +
            '        <Button variant={"tonal"} color={"primary"}>\n' +
            "          tonal\n" +
            "        </Button>\n" +
            '        <Button variant={"noPadding"} color={"primary"}>\n' +
            "          noPadding\n" +
            "        </Button>"
          }
        >
          <Button>Contained</Button>
          <Button variant={"outlined"}>outlined</Button>
          <Button variant={"text"}>text</Button>
          <Button variant={"tonal"} color={"primary"}>
            tonal
          </Button>
          <Button variant={"noPadding"} color={"primary"}>
            noPadding
          </Button>
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default BasicButtons;
